import type { Severity } from '../util/warnings';
import { getSeverityColor } from '../util/warnings';
import { Box } from '@mui/material';

type WarningSeverityIndicatorProps = {
  severity: Severity;
};

export const WarningSeverityIndicator = ({
  severity,
}: WarningSeverityIndicatorProps) => {
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: getSeverityColor(severity),
        margin: 1,
      }}
    />
  );
};

export default WarningSeverityIndicator;
